export default {"src":"/_next/static/media/icon-flag-korea.c0c4f1ce.svg","height":27,"width":40,"blurWidth":0,"blurHeight":0};